module.exports = __webpack_public_path__ + "img/5.f2404d8e.jpg";